import React from "react";
import { AlertTriangle } from "lucide-react";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";

/*
 * Shown when "Show this role in Reporting To" is being turned OFF.
 *
 * Unchecking that box does more than hide the request toggles — it also turns
 * them off for the role, so the user is told what they are about to lose
 * before it happens. Confirming only stages the change; nothing is persisted
 * until "Save Changes" on the editor is clicked.
 */
const DisableReportingToRoleModal = ({ roleName, affectedToggleNames, onCancel, onConfirm }) => (
  <div className="rpe-modal-overlay" onClick={onCancel}>
    <div className="rpe-modal rpe-modal-danger" onClick={(e) => e.stopPropagation()}>
      <div className="rpe-modal-icon-danger">
        <AlertTriangle size={20} />
      </div>
      <h2 className="rpe-modal-title">
        Turn off “Reporting To” for {roleName ? `“${roleName}”` : "this role"}?
      </h2>
      <p className="rpe-modal-subtitle">
        Employees with this role will no longer be selectable in the Employee
        “Reporting To” field.
        {affectedToggleNames.length > 0
          ? " These request permissions will also be turned off for this role when you click Save Changes:"
          : ""}
      </p>
      {affectedToggleNames.length > 0 && (
        <ul className="rpe-modal-list">
          {affectedToggleNames.map((toggleName) => (
            <li key={toggleName}>{toggleName}</li>
          ))}
        </ul>
      )}
      <div className="rpe-modal-actions rpe-modal-actions-center">
        <SecondaryButton type="button" onClick={onCancel}>
          Cancel
        </SecondaryButton>
        <PrimaryButton type="button" width="120px" onClick={onConfirm}>
          OK
        </PrimaryButton>
      </div>
    </div>
  </div>
);

export default DisableReportingToRoleModal;
